import { render } from "./CFoot.vue?vue&type=template&id=482fca30&scoped=true&ts=true"
import script from "./CFoot.vue?vue&type=script&lang=ts"
export * from "./CFoot.vue?vue&type=script&lang=ts"

import "./CFoot.vue?vue&type=style&index=0&id=482fca30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Silverfish-Vue/Silverfish-Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482fca30"]])

export default __exports__